function injectLoadGif() {
    const path = window.location.pathname;

    if ( path.includes("CompareProcess")) {
        const skeleton = document.querySelector(".sk-skeleton");
        let gifLoader = document.createElement("div");
        gifLoader.classList.add("gif-loader");
        if ( skeleton ) {
            skeleton.insertAdjacentElement("afterend", gifLoader);
        } else {
            setTimeout(() => injectLoadGif(), 200);
        }
    }
}

export { injectLoadGif };